/**
 * 开发环境下的 路由
 */

const devLogin = []


if (process.env.NODE_ENV === 'development') {
  devLogin.push(...[
    {
      path: '/login',
      name: 'DEV_LOGIN',
      meta: { title: '登录' },
      component: () => import(/* webpackChunkName: "dev-login" */'@v/devLogin'),
      hidden: true,
    },
    {
      path: '/adminlogin',
      name: 'DEV_ADMIN_LOGIN',
      meta: { title: '管理员登录' },
      component: () => import(/* webpackChunkName: "dev-login" */'@v/devLogin/admin'),
      hidden: true,
    },
  ])
}



export default devLogin